<template>
    <div
        class="BookingItem"
        @click="goToDetail"
        @keyup.enter="goToDetail"
        @keyup.space="goToDetail"
    >
        <div class="BookingItem-leftContainer">
            <img
                v-if="car?.picture?.slug"
                class="BookingItem-carPicture"
                :src="`/api/media/${car.picture.slug}`"
                alt="car"
            >
            <div
                v-else
                class="BookingItem-carPicture BookingItem-carPicture--placeholder"
            >
                <span :class="servicePlaceholderIcon" />
            </div>
            <div class="BookingItem-infoContainer">
                <span
                    class="BookingItem-carModel"
                >
                    {{ title }}
                </span>
                <div class="BookingItem-dateContainer">
                    <span class="BookingItem-date">
                        {{ displayDate }}
                    </span>
                </div>
            </div>
        </div>
        <div class="BookingItem-rightContainer">
            <div class="BookingItem-price">
                {{ amount }}
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
dayjs.extend(localizedFormat)
import _ from "lodash";
import money from "@free2move/money";
import localizedFormat from "dayjs/plugin/localizedFormat";
export default {
    props: {
        booking: {
            type: Object,
            required: true
        }
    },
    computed: {
        title() {
            return this.booking.modelId?.split('+')[0] === 'park'
                ? this.booking.from?.name
                : `${this.booking.car?.make || ''} ${this.booking.car?.model || ''}`
        },
        amount() {
            return this.booking.detail.grandTotal
                ? new money({...this.booking.detail.grandTotal, language: this.$language}).format()
                : '';
        },
        car() {
            return _.get(this.booking, 'car')
        },
        fromDate() {
            return _.get(this.booking, 'from.date', _.get(this.booking, 'date.value'))
        },
        toDate() {
            return _.get(this.booking, 'to.date', _.get(this.booking, 'date.value'))
        },
        servicePlaceholderIcon() {
            const service = this.booking.modelId ? this.booking.modelId?.split('+')[0] : 'other';
            switch (service) {
                case 'rent':
                    return 'f2m-rent-car';
                case 'carsharing':
                    return 'f2m-carsharing-car';
                case 'ride':
                    return 'f2m-driver';
                default:
                    return 'f2m-calendar';
            }
        },
        displayDate() {
            return  this.dateFormat(this.fromDate) ===  this.dateFormat(this.toDate)
                ? this.dateFormat(this.fromDate)
                : `${ this.dateFormat(this.fromDate)} > ${ this.dateFormat(this.toDate)}`;
        }
    },
    methods: {
        dateFormat(date) {
            return dayjs(date).format('L');
        },
        goToDetail() {
            const service = this.booking.modelId?.split('+')[0];
            const routeMapping = {
                'rent': 'personalAccountBookingsRentDetail',
                'carsharing': 'personalAccountBookingsCarsharingDetail',
                'ride': 'personalAccountBookingsRideDetail',
                'park': 'personalAccountBookingsParkDetail',
            };
            this.$router.push({
                name: routeMapping[service],
                params: {
                    id: this.booking._id
                }
            })
        }
    }

}
</script>
<style lang="scss" scoped>
.BookingItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: whitesmoke;
        border-radius: 10px;
    }

    &:last-child {
        border-bottom: none;
    }

    &-rightContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        color: $color-f2m-blue;
    }
    &-serviceType {
        background: #EDF2FF;
        border-radius: 10px;
        padding: 3px 10px;
    }
    &-price {
        font-size: 18px;
        line-height: 22px;
    }

    &-leftContainer {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
    }
    &-icon {
        font-size: 24px;
        color: #573781;
    }

    &-number {
        text-overflow: ellipsis;
        color: $color-f2m-pink;
        overflow: hidden;
        max-width: 200px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: calc(100vw - 250px);
        }
    }

    &-date {
        font-size: 14px;
        line-height: 17px;
        color: #8D86B6;
    }

    &-infoContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
    }

    &-carPicture {
        width: 60px;
        height: 60px;
        object-fit: contain;

        &--placeholder {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            border-radius: 50%;
            background: #EDF2FF;
            color: $color-f2m-blue;
        }
    }
    &-carModel {
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.3px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        white-space: nowrap;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: calc(100vw - 250px);
        }

    }
    &-unpaid {
        background: linear-gradient(45deg, #FF8C98 0%, #FFC080 100%);
        border-radius: 9px;
        padding: 3px 5px;
        color: $color-white;
        font-size: 12px;
        line-height: 14px;
        margin-left: 8px;
    }
}
</style>
